var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddProfession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83317 0.166748H10.1665C10.6085 0.166748 11.0325 0.342343 11.345 0.654903C11.6576 0.967464 11.8332 1.39139 11.8332 1.83341V3.50008H15.1665C15.6085 3.50008 16.0325 3.67568 16.345 3.98824C16.6576 4.3008 16.8332 4.72472 16.8332 5.16675V9.77508C16.3498 9.33342 15.7915 9.00008 15.1665 8.78341V5.16675H1.83317V14.3334H8.5665C8.6665 14.9334 8.87484 15.4917 9.1665 16.0001H1.83317C1.39114 16.0001 0.96722 15.8245 0.654659 15.5119C0.342099 15.1994 0.166504 14.7754 0.166504 14.3334V5.16675C0.166504 4.72472 0.342099 4.3008 0.654659 3.98824C0.96722 3.67568 1.39114 3.50008 1.83317 3.50008H5.1665V1.83341C5.1665 1.39139 5.3421 0.967464 5.65466 0.654903C5.96722 0.342343 6.39114 0.166748 6.83317 0.166748ZM10.1665 3.50008V1.83341H6.83317V3.50008H10.1665ZM10.1665 12.6667H12.6665V10.1667H14.3332V12.6667H16.8332V14.3334H14.3332V16.8334H12.6665V14.3334H10.1665V12.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProfession);
export default __webpack_public_path__ + "static/media/add-profession.27c7dca0.svg";
export { ForwardRef as ReactComponent };